import { render } from "./PermisosList.vue?vue&type=template&id=6714c350&scoped=true"
import script from "./PermisosList.vue?vue&type=script&lang=js"
export * from "./PermisosList.vue?vue&type=script&lang=js"

import "./PermisosList.vue?vue&type=style&index=0&id=6714c350&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6714c350"]])

export default __exports__